import { PlayerComponentCSSStyleImpl } from '../../../toolkit/player/playercss';

export class SearchListToneCardPlayerCSSStyleImpl extends PlayerComponentCSSStyleImpl
{
    getPlayDivCSSStyle(): object 
    {
        return {
            // display: "flex",
            // textAlign: "center",
            // alignItems: 'center', 
            // justifyContent: 'center', 
            // position: "absolute",
            // marginTop: "20px",
            bottom:'70px',
            // right:'30px',
            // marginLeft: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?"0px":'30px',
            // marginRight: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?"30px":'0px',
            // cursor: "pointer",
            // width: "44px",
            // height: "44px",
            // position:'absolute'
        };
    }

    // getPlayIconCSSStyle(): object 
    // {
    //     return {
    //         cursor: "pointer",
    //         height: "44px",
    //         width: "44px",
    //     };
    // }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/searchlist/searchlisttonecardplayercss.tsx